import React from 'react';
import { useNavigate } from 'react-router-dom';
import './GamesHub.css';
import { IconArrowLeft, IconBasket, IconCards, IconTicTacToe } from './icons';

const gamesGradient = 'linear-gradient(135deg, rgb(255, 152, 0) 0%, rgb(255, 87, 34) 100%)';

const games = [
  {
    key: 'catch-the-falling-food',
    title: 'Catch the Falling Food',
    subtitle: 'Catch as many as you can',
    slug: 'catch-the-falling-food',
    icon: IconBasket,
    accent: gamesGradient,
  },
  {
    key: 'food-memory-match',
    title: 'Food Memory Match',
    subtitle: 'Tap & match pairs',
    slug: 'food-memory-match',
    icon: IconCards,
    accent: gamesGradient,
  },
  {
    key: 'tic-tac-toe',
    title: 'Tic-Tac-Toe',
    subtitle: 'Classic 3×3',
    slug: 'tic-tac-toe',
    icon: IconTicTacToe,
    accent: gamesGradient,
  },
];

export default function GamesHub() {
  const navigate = useNavigate();

  return (
    <div className="gameshub-page">
      <header className="gameshub-header">
        <button className="gameshub-back" onClick={() => navigate(-1)} aria-label="Back">
          <IconArrowLeft size={20} />
        </button>
        <div className="gameshub-title">
          <h1>Games</h1>
          <p>Pick a quick game while you wait.</p>
        </div>
      </header>

      <main className="gameshub-grid" role="list">
        {games.map((g) => (
          <button
            key={g.key}
            className="gameshub-card"
            role="listitem"
            onClick={() => navigate(`/customer/games/${g.slug}`)}
          >
            <div className="gameshub-card-accent" style={{ background: g.accent }} />

            <div className="gameshub-card-body">
              <div className="gameshub-card-top">
                <div className="gameshub-card-icon" style={{ background: g.accent }} aria-hidden="true">
                  {(() => {
                    const Icon = g.icon;
                    return <Icon size={20} />;
                  })()}
                </div>
                <div className="gameshub-card-title">{g.title}</div>
              </div>

              <div className="gameshub-card-subtitle">{g.subtitle}</div>
            </div>

            <div className="gameshub-card-cta">
              <span>Start</span>
            </div>
          </button>
        ))}
      </main>
    </div>
  );
}
